import $ from 'jquery';
import { getMetadata } from '~loader/loader-utils';

export const composeMetadataCanvasNavText = () => {
  const metadata = getMetadata();
  const summaryParts = [`${metadata.projectTypeName} ${metadata.formatName}`];
  if (metadata.templatesCategoryName)
    summaryParts.push(metadata.templatesCategoryName);

  const summary = summaryParts.join(' | ');

  const serviceBtn = `
    <a
      id="navbar-servizio-btn"
      class="g-btn g-btn-outline g-btn-size-sm linkServizio"
      href="${process.env.ETERNO_URL}/index.php?page=detaildefunto&objectid=${
    metadata.servizioId || ''
  }"
      target="_blank"
      data-tracking-eterno-open-service
      data-toggle="tooltip"
      data-placement="bottom"
      title="Apri servizio in Eterno"
    >
      ${metadata.servizioName ? metadata.servizioName : 'Servizio'}
    </a>`;

  const canvasNavInfo = `
    <div class="navbar-canvas-metadata-inner">
      ${serviceBtn}
      <div class="navbar-canvas-metadata-line navbar-canvas-metadata-summary">${summary}</div>
    </div>`;

  $('#navbar-canvas-metadata').html(canvasNavInfo);
};
